"use strict";
var Observable_1 = require('../../Observable');
var multicast_1 = require('../../operator/multicast');
Observable_1.Observable.prototype.multicast = multicast_1.multicast;
//# sourceMappingURL=multicast.js.map


//////////////////
// WEBPACK FOOTER
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/~/rxjs/add/operator/multicast.js
// module id = PatI
// module chunks = 5